import React from 'react';
import AccountingLedgerFilters, { AccountingLedgerFiltersProps } from '../accounting/AccountingLedgerFilters';

type ARFiltersProps = Omit<AccountingLedgerFiltersProps, 'view'>;

const ARFilters: React.FC<ARFiltersProps> = (props) => (
    <AccountingLedgerFilters {...props} view="ar" />
);

export default ARFilters;
